module.exports = __webpack_public_path__ + "img/SMART.ac874fbf.svg";